class Vacancies {

    constructor() {
        let $vacancies = $('.js-section.vacancies');

        $(window).on('scroll', vacanciesInViewport);

        function vacanciesInViewport () {
            if ($vacancies.is(':in-viewport')) {
                var props = $vacancies[0].getBoundingClientRect();

                if (props.top < screen.availHeight / 2 && props.bottom > screen.availHeight / 2) {
                    $(document).trigger('counters:main_vacancies_block_show');
                    $(window).off('scroll', vacanciesInViewport);
                }
            }
        }

        $('.vacancies__item').on('click', function () {
            if (!$(this).find('img[src$="vacancy_closed.png"]').length) {
                $(document).trigger('counters:main_vacancies_block_click', $(this).find('.vacancies__card-title').text());
            }
        });

        $('.js-vacancy-invitation-form-close').click(function() {
            $('.js-vacancy-invitation-form').slideUp();
        });

        $('.js-vacancy-invitation-form-open').click(function() {
            $('.js-vacancy-invitation-form').slideDown();
        });
    }
}

let invitation = new Vacancies();

export default invitation;
